// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1kUdA","colMaxWidth":"Table_colMaxWidth__uIWMA"};